import { render, staticRenderFns } from "./club.vue?vue&type=template&id=d3974a5a&scoped=true&"
import script from "./club.vue?vue&type=script&lang=js&"
export * from "./club.vue?vue&type=script&lang=js&"
import style0 from "./club.vue?vue&type=style&index=0&id=d3974a5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3974a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3974a5a')) {
      api.createRecord('d3974a5a', component.options)
    } else {
      api.reload('d3974a5a', component.options)
    }
    module.hot.accept("./club.vue?vue&type=template&id=d3974a5a&scoped=true&", function () {
      api.rerender('d3974a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/search2/club.vue"
export default component.exports